export enum AppColors {
  blackBlue = "#0D0C34",
  darkBlue = "#2B3B76",
  darkRed = "#8B000099",
  lightBlue = "#5478D0",
  gold = "#E4C67F",
  brown = "#573318",
}